import React from 'react';
import './Footer.css';
import logo from '../assets/img/logo2.png';
import fb from '../assets/img/facebook-logo-button.svg';
import insta from '../assets/img/instagram.svg';

function Footer() {
  return (
    <footer id="contact">
      <div className="container">
        <div>
          <img src={logo} alt="podolog logo" className="footer-logo"></img>
          <h3>Podomedis</h3>
        </div>
        <div>
          <h3>Izabela Kisza</h3>
          <ul>
            <li><a href="http://maps.google.com/?q=ul. Bielska 37 43-400 Cieszyn">ul. Bielska 37 / II piętro</a></li>
            <li>43-400 Cieszyn</li>
            <li><a href="tel:+48 735-049-669">tel. +48 735-049-669</a></li>
            <li><a href="mailto:gabinet@podolog.cieszyn.pl">gabinet@podolog.cieszyn.pl</a></li>
            <li><a href="http://www.podolog.cieszyn.pl">www.podolog.cieszyn.pl</a></li>
          </ul>
        </div>

        <p>
          <a href="https://facebook.com">
            <img src={fb} alt="Facebook podolog cieszyn logo"></img>
          </a>

          <a href="https://instagram.com">
            <img src={insta} alt="Instagram podolog cieszyn logo"></img>
          </a>
        </p>
      </div>
    </footer>
  );
}

export default Footer;
